/// <reference path="../../components/fixed-hero.js" />
/// <reference path="../../components/grow-fade.js" />

(function ($) {
    // Breadcrumb navigation user experience for smaller screen sizes, toggles open close breadcumbs
    function mobileBreadCrumbs() {
        evo.$.body.on('click', '#results-banner-expand', function () {
            $('#breadcrumb-links').slideToggle("fast");
            evo.$.body.toggleClass('breadcrumb-open');
            $(this).blur();

            if (evo.$.body.hasClass('breadcrumb-open')) {
                $('#results-banner-expand').attr('aria-expanded', 'true');
            } else {
                $('#results-banner-expand').attr('aria-expanded', 'false');
            }
        });
        evo.$.body.on('refresh.results', function () { evo.$.body.removeClass('breadcrumb-open'); });
    };
    function brandLinksViewMore() {
        evo.$.body.on('click', '#brands-links-toggle', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            $(this).parent().toggleClass('brand-links-open');
            $('.brand-links-open #brands-links-toggle').scrollToID({ speed: 250 });
        });
    }

    function photoCaption() {
        evo.$.body.on('click', '.js-caption-toggle', function () {
            $(this).toggleClass('js-active');
        });
    }
    $(function () {
        $('.js-fixed-hero').fixedHero().growFade();
        $('.js-scrolltoid').scrollToID({ speed: 667, offset: -20 });
        $(brandLinksViewMore);
        // init for mobile
        if (evo.isMobile) {
            photoCaption();
            mobileBreadCrumbs();
        }
    });

    // Bind the product thumb click events to push to the Google dataLayer.
    evo.$.body.on("click", ".js-product-thumb-link, .js-product-thumb-details-link", function () {
        var $productPageId = $(this).data("unique-id");

        window.dataLayerManager.pushProductClick($productPageId, "Results");
    });
})(jQuery);